import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

// Attach access token to every request via Bearer header
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mfm_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Rolling-window auth: backend stamps `X-Refreshed-Token` on the response
// any time the current token is past the halfway mark of its 30-day TTL.
// Swap the new token into localStorage transparently so active users never
// see a login screen. Inactive accounts still expire after 30 unused days.
api.interceptors.response.use((response) => {
  const refreshed = response?.headers?.['x-refreshed-token'];
  if (refreshed) {
    localStorage.setItem('mfm_token', refreshed);
  }
  return response;
});

export default api;
